import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithTimeout from './baseQueryWithTimeout';

export const renewalApi = createApi({
  reducerPath: 'renewalApi',
  baseQuery: baseQueryWithTimeout,
  endpoints: (builder) => ({
    // Get
    getRenewalEligibility: builder.query({
      query: (auth0Token) => {
        return {
          url: '/api/renewal/eligibility',
          method: 'GET',
          headers: {
            customAuthToken: auth0Token
          }
        };
      }
    }),
    getRenewalSummary: builder.query({
      query: (data) => {
        return {
          url: `/api/renewal/${data.policyNumber}`,
          headers: {
            customAuthToken: data.auth0Token
          }
        };
      }
    }),
    createRenewalQuote: builder.query({
      query: ({ data, auth0Token }) => {
        return {
          url: `/api/renewal/quote/create`,
          method: 'POST',
          headers: {
            customAuthToken: auth0Token
          },
          body: data
        };
      }
    }),
    submitRenewal: builder.mutation({
      query: ({ data, auth0Token }) => {
        return {
          url: `/api/renewal/submit`,
          method: 'POST',
          headers: {
            customAuthToken: auth0Token
          },
          body: data
        };
      }
    })
  })
});

export const {
  useGetRenewalEligibilityQuery,
  useGetRenewalSummaryQuery,
  useCreateRenewalQuoteQuery,
  useSubmitRenewalMutation
} = renewalApi;
